module.exports = {
  title: 'Clerk Toast with Reanimated',
  author: 'Enzo Manuel Mangano',
  date: '2024-09-03',
  slug: 'clerk-toast',
  tags: ['reanimated'],
};
